<div>Date: {{clientCommunication?.created}}</div>
<div>From: {{clientCommunication?.sender}}</div>
<div>Subject: {{clientCommunication?.subject}}</div>

<ul class="list-group m-2 w-50" *ngIf="clientCommunication?.emailProperties != null && clientCommunication?.emailProperties.attachments.length>0">
  <li class="list-group-item" *ngFor="let attachment of clientCommunication?.emailProperties.attachments; trackBy: trackById">
    <a href="/ws/api/communication/{{clientCommunication.id}}/attachment/{{attachment.uid}}">{{attachment.fileName}}</a>
  </li>
</ul>
